import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const t25IconContainerStyles = {
	small: xcss({
		width: '16px',
		height: '16px',
	}),
	medium: xcss({
		width: '24px',
		height: '24px',
	}),
	large: xcss({
		width: '32px',
		height: '32px',
	}),
	//t25 tile icons do not get bumped up to 40/48px to avoid additional padding
	xlarge: xcss({
		width: '32x',
		height: '32px',
	}),
} as const;

type Size = 'small' | 'medium' | 'large' | 'xlarge';

export interface SVGIconProps {
	glyph: () => JSX.Element;
	label?: string;
	size: Size;
}

const iconStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const SVGIcon = ({ glyph: SVG, label, size }: SVGIconProps): React.JSX.Element => {
	return (
		<Box xcss={[t25IconContainerStyles[size], iconStyles]} aria-label={label}>
			<SVG />
		</Box>
	);
};
